import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Helmet } from "react-helmet";
import UnsubscribeBlock from "../util/UnsubscribeBlock";
import { getLink } from '../../dataProvider/links';
import { sendContact } from '../../actions/contact'

import dropdownIcon from "../../img/v1/user/time-slot-dropdown.svg"
import accountIconV2 from "../../img/v2/user/unsubscribe-icon.png"
import dateIconV2 from "../../img/v2/user/time-icon.png"
import emailIconV2 from "../../img/v2/contact/email.png"
import phoneIconV2 from "../../img/v2/contact/phone.png"
import nameIconV2 from "../../img/v2/contact/name.png"

import "../../scss/v2/user/unsubscribe.scss"

function Unsubscribe(props) {

    const { t, i18n } = useTranslation();
    const [modal, setModal] = useState(false);
    const [success, setSuccess] = useState(false);
    const [pending, setPending] = useState(false);
    const [modalFirstName, setModalFirstName] = useState('');
    const [modalLastName, setModalLastName] = useState('');
    const [modalEmail, setModalEmail] = useState('');
    const [modalPhone, setModalPhone] = useState('');
    const [modalTime, setModalTime] = useState('slot1');

    const openModal = () => {
        setModal(true)
    }

    const handleClose = () => {
        setModal(false)
    }

    const handleSubmit = async () => {
        try {
            setPending(true)
            await props.dispatch(sendContact({
                lastName: modalLastName,
                firstName: modalFirstName,
                email: modalEmail,
                url: window.location.href,
                subject: `Callback for ${modalEmail}`,
                content: `Callback: \r\n email: ${modalEmail} \r\n phone: ${modalPhone} \r\n time: ${modalTime}`
            }))
            setSuccess(true)
        } catch (error) {
            console.error(error)
            setSuccess(false);
        }
        setPending(false)
    }

    useEffect(() => {
        i18n.changeLanguage(props.lang);
    }, [i18n, props.lang])

    const renderModalSubmit = () => {
        if (success || pending) return null
        return (<button className="button orange-button" onClick={handleSubmit}>{t('unsubscribe.modal.button')}</button>)
    }

    return (
        <>
            <Helmet>
                <title>{t("meta.title.unsubscribe")}</title>
                <meta name="description" content={t("meta.description.unsubscribe")} />
            </Helmet>
            <div className="unsubscribe container">
                <div className="row">
                    <div className="col-12 col-lg-10 offset-lg-1">
                        <div className="row">
                                <div className="col-12 mt-5">
                                    <div className="unsubscribe-top-card">
                                        <h1 className="unsubscribe-top-card-title">{t('unsubscribe.topCard.title')}</h1>
                                        <p className="unsubscribe-top-card-subtitle">{t('unsubscribe.topCard.subtitle')}</p>
                                        <div className="row">
                                            <div className="col-12 col-lg-6">
                                                <div className="unsubscribe-top-card-description" dangerouslySetInnerHTML={{ __html: t('unsubscribe.topCard.text') }} />
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <div className="unsubscribe-top-card-green-container">
                                                    <div className="unsubscribe-top-card-green-content">
                                                        <h2 className="unsubscribe-top-card-green-container-title">{t('unsubscribe.topCard.greenContainer.title')}</h2>
                                                        <p className="unsubscribe-top-card-green-container-text">{t('unsubscribe.topCard.greenContainer.text')}</p>
                                                        <div className="row">
                                                            <div className="col-12 col-lg-6 text-center">
                                                                <Link to={getLink('contact', i18n.language)}>
                                                                    <button className="button orange-button">{t('unsubscribe.topCard.greenContainer.contactButton')}</button>
                                                                </Link>
                                                            </div>
                                                            <div className="col-12 col-lg-6 text-center">
                                                                <button className="button orange-button" onClick={openModal}>{t('unsubscribe.topCard.greenContainer.callButton')}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <div className="col-12 col-lg-6">
                                <UnsubscribeBlock />
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className={`unsubscribe-small-card unsubscribe-account-card${alert ? " bigger-card" : ''}`}>
                                    <h2 className="unsubscribe-small-card-title">{t('unsubscribe.accountCard.title')}</h2>
                                        <img className="img img-fluid unsubscribe-account-card-image" src={accountIconV2} alt={accountIconV2} />
                                    <p className="unsubscribe-account-card-text">{t('unsubscribe.accountCard.text')}</p>
                                    <Link to={getLink('login', i18n.language)}>
                                        <button className="button orange-button">{t('unsubscribe.accountCard.button')}</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal size="lg" className="modal-unsubscribe" show={modal} onHide={handleClose}>
                <Modal.Header>
                    <h2 className="modal-unsubscribe-title">{t('unsubscribe.modal.title')}</h2>
                    <button className="modal-unsubscribe-close-button" onClick={handleClose}>x</button>
                </Modal.Header>
                <Modal.Body>
                    {success ? <div className="alert alert-success">{t('unsubscribe.modal.success')}</div> : null}
                    <div className="row"><div className="col-12 col-lg-8 offset-lg-2"><div className="row">
                        <div className="col-12 col-lg-6">
                            <div className="unsubscribe-input-group">
                                <p className="unsubscribe-input-group-label">{t('unsubscribe.modal.label.lastName')}</p>
                                <input className="unsubscribe-input-group-input" placeholder={t('unsubscribe.modal.placeholder.lastName')} onChange={(event) => { setModalFirstName(event.target.value) }} />
                                <div className="unsubscribe-input-group-left-icon">
                                        <img className="img img-fluid unsubscribe-input-group-left-icon-svg" src={nameIconV2} alt={nameIconV2} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="unsubscribe-input-group">
                                <p className="unsubscribe-input-group-label">{t('unsubscribe.modal.label.firstName')}</p>
                                <input className="unsubscribe-input-group-input" placeholder={t('unsubscribe.modal.placeholder.firstName')} onChange={(event) => { setModalLastName(event.target.value) }} />
                                <div className="unsubscribe-input-group-left-icon">
                                        <img className="img img-fluid unsubscribe-input-group-left-icon-svg" src={nameIconV2} alt={nameIconV2} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="unsubscribe-input-group">
                                <p className="unsubscribe-input-group-label">{t('unsubscribe.modal.label.email')}</p>
                                <input className="unsubscribe-input-group-input" placeholder={t('unsubscribe.modal.placeholder.email')} onChange={(event) => { setModalEmail(event.target.value) }} />
                                <div className="unsubscribe-input-group-left-icon">
                                        <img className="img img-fluid unsubscribe-input-group-left-icon-svg" src={emailIconV2} alt={emailIconV2} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="unsubscribe-input-group">
                                <p className="unsubscribe-input-group-label">{t('unsubscribe.modal.label.phone')}</p>
                                <input className="unsubscribe-input-group-input" placeholder={t('unsubscribe.modal.placeholder.phone')} onChange={(event) => { setModalPhone(event.target.value) }} />
                                <div className="unsubscribe-input-group-left-icon">
                                        <img className="img img-fluid unsubscribe-input-group-left-icon-svg" src={phoneIconV2} alt={phoneIconV2} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="unsubscribe-input-group">
                                <p className="unsubscribe-input-group-label">{t('unsubscribe.modal.label.time')}</p>
                                <select id="unsubscribeModalSelect" className="unsubscribe-input-group-input" value={modalTime}
                                    onChange={(event) => { setModalTime(event.target.value); }}>
                                    <option value={t('unsubscribe.modal.select.slot.1')}>{t('unsubscribe.modal.select.slot.1')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.2')}>{t('unsubscribe.modal.select.slot.2')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.3')}>{t('unsubscribe.modal.select.slot.3')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.4')}>{t('unsubscribe.modal.select.slot.4')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.5')}>{t('unsubscribe.modal.select.slot.5')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.6')}>{t('unsubscribe.modal.select.slot.6')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.7')}>{t('unsubscribe.modal.select.slot.7')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.8')}>{t('unsubscribe.modal.select.slot.8')}</option>
                                    <option value={t('unsubscribe.modal.select.slot.9')}>{t('unsubscribe.modal.select.slot.9')}</option>
                                </select>
                                <img className="img img-fluid unsubscribe-select-dropdown" src={dropdownIcon} alt={dropdownIcon} />
                                <div className="unsubscribe-input-group-left-icon">
                                        <img className="img img-fluid unsubscribe-input-group-left-icon-svg" src={dateIconV2} alt={dateIconV2} />
                                </div>
                            </div>
                        </div>
                    </div></div></div>
                </Modal.Body>
                <Modal.Footer>
                    {renderModalSubmit()}
                </Modal.Footer>
            </Modal>
        </>
    )

}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
